import type { Toast } from '@hm-group/bads-react'
import { Subject } from 'rxjs'

export type NotificationToastPayload = Omit<Toast, 'id'>

const AUTO_CLOSE_TIMEOUT = 3000
const notificationToastSubject = new Subject<NotificationToastPayload | null>()

export const SnackBarService = {
  setToast: (toast: NotificationToastPayload): void => notificationToastSubject.next(toast),
  closeToast: (): void => notificationToastSubject.next(null),
  getToast: () => notificationToastSubject.asObservable(),
}

export const createSnackBar = (open: boolean): void => {
  if (!open) SnackBarService.closeToast()
}

export const defaultSnackBar = (title: string, subtitle = ''): void => {
  SnackBarService.setToast({ title, subtitle, type: 'information' })
}

export const warningSnackBar = (title: string, subtitle = ''): void => {
  SnackBarService.setToast({
    title,
    subtitle,
    type: 'warning',
    timeout: AUTO_CLOSE_TIMEOUT,
  })
}

export const errorSnackBar = (title: string, subtitle = ''): void => {
  SnackBarService.setToast({ title, subtitle, type: 'error' })
}

export const successSnackBar = (title: string, subtitle = ''): void => {
  SnackBarService.setToast({
    title,
    subtitle,
    type: 'success',
    timeout: AUTO_CLOSE_TIMEOUT,
  })
}
